import MainLayout from "../layout/MainLayout";
import HomePage from "../features/home/HomePage";
import TimelineLandingPage from "../features/timeline/pages/TimelineLandingPage";
import TimelineEntryPage from "../features/timeline/pages/TimelineEntryPage";
import KontaktPage from "../pages/Kontakt/KontaktPage";
import UnderConstructionPage from "../pages/NotFound/UnderConstructionPage";
import NotFoundPage from "../pages/NotFound/NotFoundPage";
import KerinHistoriaMisja from "../pages/KerinHistoriaMisja/KerinHistoriaMisja";
export const routes = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "miejsca", element: <HomePage initialSection="miejsca" /> },
      { path: "epoki", element: <HomePage initialSection="epoki" /> },
      { path: "kontakt", element: <KontaktPage /> },
      { path: "sciezka-czasu", element: <TimelineLandingPage /> },
      { path: "sciezka-czasu/:slug", element: <TimelineEntryPage /> },
      { path: "kerin-historia-i-misja", element: <KerinHistoriaMisja /> },
      { path: "w-budowie", element: <UnderConstructionPage /> },
      { path: "*", element: <NotFoundPage /> }
    ]
  }
];